import { IRootState } from '../../../../store'
import { IAirwayState } from '../store/airway.types'

export const getAirwaySelector = (state: IRootState): IAirwayState => state.airway
